export default class Indicator {
	constructor({name, description, url, group_id, id, company_id, added_on, update_on, group_name}) {
		this.name = name || "";
		this.description = description || "";
		this.url = url || "";
		this.group_id = group_id || 0;
		this.id = id || 0;
		this.company_id = company_id || 0;
		this.added_on = added_on || "";
		this.update_on = update_on || "";
		this.group_name = group_name || "";
	}
}
